module.exports = __webpack_public_path__ + "img/head-default-personal.f73e0ad7.png";